import { axiosInstance, timeout5SecAxiosInstance } from '@/worker/commands/config/apiInstance';
import type { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';

type AxiosRequestConfigWithAdditional = AxiosRequestConfig & {
  frameName?: string;
  isPolling?: boolean;
  isTimeout?: boolean;
  responseType?: ResponseType;
};

// timeout 값에 따라 적절한 axios 인스턴스를 선택하는 mutator
export const customAxiosInstance = <T>(
  config: AxiosRequestConfigWithAdditional,
  options?: AxiosRequestConfigWithAdditional,
): Promise<AxiosResponse<T>> => {
  // config.params에서 frameName 분리 (API 파라미터가 아닌 트레이싱용)
  // config.params에서 responseType이 넘어오는 경우 예외처리
  const {
    frameName: paramsFrameName,
    responseType: paramsResponseType,
    ...restConfigParams
  } = config.params ?? {};
  // options.params에서 isTimeout 분리 (API 파라미터가 아닌 인스턴스 선택용)
  const { isTimeout: useTimeoutInstance, ...restParams } = options?.params ?? {};

  const mergedConfig: AxiosRequestConfigWithAdditional = {
    ...config,
    ...options,
    // frameName 우선순위: params > options > config
    frameName: paramsFrameName ?? options?.frameName ?? config.frameName,
    params: {
      ...restConfigParams,
      ...restParams,
    },
    responseType: paramsResponseType ?? options?.responseType ?? 'json',
  };

  // timeout이 설정되어 있거나 isTimeout 플래그가 true이면 timeout5SecAxiosInstance 사용
  const isTimeout =
    useTimeoutInstance || (mergedConfig.timeout !== undefined && mergedConfig.timeout <= 5000);
  const instance = isTimeout ? timeout5SecAxiosInstance : axiosInstance;

  return instance(mergedConfig);
};

export type ErrorType<Error> = Error;
export type BodyType<BodyData> = BodyData;

// SecondParameter 타입 정의
export type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];
